export const regex = '^[1-9][0-9]*$';
export default regex;
